import axios from "axios";

const headers = new Headers();
headers.append("Content-Type", "application/json");
headers.append("Authorization", `${process.env.REACT_APP_ENCLAVE_SDK_KEY}`);

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getStakeOpportunities = async () => {
  const result = await axios.get(BASE_URL + "/yield-opportunities", {
    headers: {
      "Content-Type": "application/json",
      Authorization: process.env.REACT_APP_ENCLAVE_SDK_KEY,
    },
  });

  return result.data;
};

export const getHotTokens = async () => {
  const result = await axios.get(BASE_URL + "/hot-tokens", {
    headers: {
      "Content-Type": "application/json",
      Authorization: process.env.REACT_APP_ENCLAVE_SDK_KEY,
    },
  });

  return result.data;
};

export const getAllTokens = async () => {
  const result = await axios.get(BASE_URL + "/all-tokens", {
    headers: {
      "Content-Type": "application/json",
      Authorization: process.env.REACT_APP_ENCLAVE_SDK_KEY,
    },
  });

  return result.data;
};

export const getTopTokens = async () => {
  const result = await axios.get(BASE_URL + "/token/top-tokens", {
    headers: {
      "Content-Type": "application/json",
      Authorization: process.env.REACT_APP_ENCLAVE_SDK_KEY,
    },
  });
  console.log({ result });
  return result.data?.data?.listTopTokens;
};

export const getNativeTokenPriceData = async () => {
  const result = await axios.get(BASE_URL + "/native-token-prices", {
    headers: {
      "Content-Type": "application/json",
      Authorization: process.env.REACT_APP_ENCLAVE_SDK_KEY,
    },
  });

  return result.data;
};

export const getStocks = async () => {
  // const result = await axios.get(
  //   "https://api.backed.fi/api/v1/client/sweepingWallets",
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       "X-API-KEY": process.env.REACT_APP_BACKEDFI_CLIENT_API_KEY,
  //     },
  //   }
  // );

  return {
    issue: [
      {
        address: "0x5f21e8d593b775f24b2143b926e7116d3e24c658",
        token: {
          name: "Backed CSPX Core S&P 500",
          symbol: "bCSPX",
          networks: ["Ethereum", "Polygon"],
          image: "https://defi.backed.fi/icons/products/bCSPX.svg",
          gain: "12.8%",
        },
      },
      {
        address: "0x316ed630d30816b246b83ea3535938a1fc1be2a5",
        token: {
          name: "Backed IBTA $ Treasury Bond 1-3yr",
          symbol: "bIB01",
          networks: ["Polygon", "Ethereum"],
          image: "https://defi.backed.fi/icons/products/bIB01.svg",
          gain: "12%",
        },
      },
      {
        address: "0x316ed630d30816b246b83ea3535938a1fc1be2a5",
        token: {
          name: "Backed GameStop Corp",
          symbol: "bGME",
          networks: ["Polygon", "Ethereum"],
          image: "https://defi.backed.fi/icons/products/bGME.svg",
          gain: "10%",
        },
      },
      {
        address: "0x316ed630d30816b246b83ea3535938a1fc1be2a5",
        token: {
          name: "Backed Microsoft Corp",
          symbol: "bMSFT",
          networks: ["Polygon", "Ethereum"],
          image: "https://defi.backed.fi/icons/products/bMSFT.svg",
          gain: "6%",
        },
      },
    ],
    redeem: {
      address: "0x499ca77f59f760a6da5e30c0b591e6045805c2d1",
    },
  };
};
